export class PlaceConvention {

  conventionNumber: string;
  conventionDate;
  placeId: number;

}
